import styled from 'styled-components';
import { getSpacing } from 'stylesheet';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  grid-row-gap: ${getSpacing(3)};
`;

/* ### For Printable View ### */

export const PrintableContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: ${getSpacing(2)};
  margin-bottom: ${getSpacing(4)};
`;
